export default __webpack_public_path__ + "static/media/bg23.b8d62785.png";